// collection collection tab section mobile drawer js code start 
document.addEventListener('DOMContentLoaded', function() {
  const body = document.body;
  const tabSection = document.querySelector('.custom-collections-tab-section');
  const filterPanel = document.querySelector('.facets__panel.has-mob-drawer');

  function initMobileDrawer() {
    document.addEventListener('click', mobileClickHandler);
  }

  function destroyMobileDrawer() {
    document.removeEventListener('click', mobileClickHandler);
    // Clean up any active states if resizing to desktop
    if (tabSection) tabSection.classList.remove('active');
    body.classList.remove('has-custom-drawer');
  }

  function mobileClickHandler(e) {
    const sortBtn = e.target.closest('.custom-sort-collection');
    const closeBtn = e.target.closest('.custom-collections-tab-popup-close');
    const filterLabel = e.target.closest('.has-mob-drawer-label');
    const filterCloseBtn = e.target.closest('.custom-collections-filter-popup-close');
    const filterOptLabel = e.target.closest('.custom-collections-filter-opt label');

    if (sortBtn && tabSection) {
      e.preventDefault();
      tabSection.classList.add('active');
      body.classList.add('has-custom-drawer');
      e.stopPropagation();
    }

    if (closeBtn && tabSection) {
      e.preventDefault();
      tabSection.classList.remove('active');
      body.classList.remove('has-custom-drawer');
    }

    if (filterLabel && filterPanel) {
      filterPanel.click();
      body.classList.add('has-custom-drawer');
    }

    if (filterCloseBtn && filterPanel) {
      e.preventDefault();
      filterPanel.click();
      body.classList.remove('has-custom-drawer');
    }
    if (filterOptLabel) {
        body.classList.remove('has-custom-drawer');
    }

    const clickedInsideTab = e.target.closest('.custom-collections-tab-section');
    const clickedInsideFilter = e.target.closest('.facets__panel.has-mob-drawer');
    const clickedTrigger = sortBtn || filterLabel;

    if (!clickedInsideTab && !clickedInsideFilter && !clickedTrigger) {
      if (tabSection && tabSection.classList.contains('active')) {
        tabSection.classList.remove('active');
      }
      if (filterPanel && filterPanel.classList.contains('active')) {
        filterPanel.click();
      }
      body.classList.remove('has-custom-drawer');
    }
  }

  function checkScreenSize() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      initMobileDrawer();
    } else {
      destroyMobileDrawer();
    }
  }

  checkScreenSize();

  window.addEventListener('resize', checkScreenSize);
});

// collection collection tab section mobile drawer js code end


// js code for article page sticky navigation start
(function () {
  const toolbar = document.querySelector('.article-custom-sticky-navigation');
  const header = document.getElementById('header-component');

  if (!toolbar || !header) return;

  function setToolbarPosition() {
    toolbar.style.top = (header.offsetHeight - 2) + 'px';
  }

  function toggleToolbarClass() {
    if (window.scrollY > header.offsetHeight) {
      toolbar.classList.add('active');
    } else {
      toolbar.classList.remove('active');
    }
  }

  function init() {
    setToolbarPosition();
    toggleToolbarClass();
    window.addEventListener('scroll', toggleToolbarClass);
    window.addEventListener('resize', function () {
      setToolbarPosition();
      toggleToolbarClass();
    });
  }

  function destroy() {
    window.removeEventListener('scroll', toggleToolbarClass);
    toolbar.classList.remove('active');
  }

  var mq = window.matchMedia('(min-width: 768px)');

  function handleBreakpoint(e) {
    if (e.matches) {
      init();
    } else {
      destroy();
    }
  }

  mq.addEventListener('change', handleBreakpoint);
  handleBreakpoint(mq);
})();
// js code for article page sticky navigation end

// // Location redirect code start

// IPRedirect.init({
//         "redirect_use": true,
//         "redirect_relative": true,
//         "redirect_force": true,
//         "ip_white_list": "180.150.28.133",
//         "redirect_catch_all_countries": "US, CA, MX, PR",
//         "redirect_catch_all_url": "https:\/\/store.happymammoth.com",
//         "redirect_catch_all_name": "US SITE",
//         "redirect_catch_all_countries2": "EU, AD, AL, AT, BA, BE, BG, BY, CH, CS, CY, CZ, DE, DK, EE, ES, FI, FO, FR, FX, GB, UK, GI, GR, HR, HU, IE, IS, IT, LI, LT, LU, LV, MC, MD, MK, MT, NL, NO, PL, PT, RO, RS, SE, SI, SJ, SK, SM, UA, VA",
//         "redirect_catch_all_url2": "https:\/\/eu.happymammoth.com",
//         "redirect_catch_all_name2": "EU SITE",
//         "redirect_catch_all_countries3": "",
//         "redirect_catch_all_url3": "",
//         "redirect_catch_all_name3": "",
//         "dns_prefetch_domains": "cdn.shopify.com,www.googletagmanager.com,www.google-analytics.com",
//         "dns_preconnect_domains": "https:\/\/cdn.shopify.com,https:\/\/www.google.com,https:\/\/www.google.com.au,https:\/\/stats.g.doubleclick.net,connect.facebook.net,https:\/\/fonts.googleapis.com",
// });
// IPRedirect.run();

// // Location redirect code end